module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna@2x-5fa0602c.png";